// import api from '../../api'
import * as types from '../mutation-types'

// initial state
const state = {
  error: null,
  notice: null,
  loading: true,
  loading_progress: 0
}

// getters
const getters = {
  isLoading: state => state.loading_progress < 100,
  loadingProgress: state => state.loading_progress,
  loadingIncrement: state => { return 100 / window.SETTINGS.LOADING_SEGMENTS },
  error: state => state.error
}

// actions
const actions = {
  clearError ({ commit }) {
    commit(types.STORE_CLEAR_ERROR)
  },
  resetLoading ({ commit }) {
    commit(types.RESET_LOADING_PROGRESS)
  }

}

// mutations
const mutations = {
  [types.INCREMENT_LOADING_PROGRESS] (state, val) {
    state.loading_progress = Math.min(state.loading_progress + getters.loadingIncrement(), 100)
  },

  [types.RESET_LOADING_PROGRESS] (state) {
    state.loading_progress = 0
  },

  [types.STORE_CLEAR_ERROR] (state) {
    state.error = null
  },
  [types.STORE_FETCHED_ERROR] (state, error) {
    state.error = error
  }

}

export default {
  state,
  getters,
  actions,
  mutations
}



// WEBPACK FOOTER //
// ./src/store/modules/hub.js